export default {
  deferredPrompt: ({ deferredPrompt }) => deferredPrompt
};
